//dummyMemes.js



const dummyMemes = [

{
  id: 1,
  projectName: "Hamster Kombat",
  content: "/assets/memes/game1.png",
  weight: 1,
  logo: "/assets/logos/logo_hamster.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true, // New field to indicate if game has a token
    network: "TON",
    price: "0.003",
    marketCap: "0.24B",
    priceChange24h: -1,
    contract: "EQAJ8uWd7EBqsmpSWaRdf_I-8R8-XHwh3gsNKhy-UrdrPcUo",
    buyLink: "https://www.binance.com/en/trade/HMSTR_USDT?ref=37754157",
    description: "Hamster Kombat is a former tap-to-earn game turned expansive HamsterVerse ecosystem, where players engage in a variety of mini-games and dApps beyond its original tapping mechanic. The $HMSTR token, released on September 26, 2024, on The Open Network (TON), saw no presale but powers its 300 million-strong user base.",
    sector: "Play", 
    sectorUrl: "https://t.me/hamster_koMbat_bot/start?startapp=kentId1812207291",
    projectType: "Game Hub",
    buttons: [
      {
        label: "Open Website",
        url: "https://hamsterkombat.io/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/ton/pools/EQAlNk4VwBlVV-sQr0UYe5souU_xbTof54Fd9qewwN1N7pXL"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/hamster_kombat"
      },
      {
        label: "Follow X",
        url: "https://x.com/hamster_kombat"
      },
      {
        label: "Follow Youtube",
        url: "https://x.com/hamster_kombat"
      }
    ]
  }
},
{
  id: 2,
  projectName: "Hamster Kombat",
  content: "/assets/memes/game2.png",
  weight: 1,
  logo: "/assets/logos/logo_hamster.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true,
    network: "TON",
    price: "0.003",
    marketCap: "0.24B",
    priceChange24h: -1,
    contract: "EQAJ8uWd7EBqsmpSWaRdf_I-8R8-XHwh3gsNKhy-UrdrPcUo",
    buyLink: "https://www.binance.com/en/trade/HMSTR_USDT?ref=37754157",
    description: "Hamster Kombat is a former tap-to-earn game turned expansive HamsterVerse ecosystem, where players engage in a variety of mini-games and dApps beyond its original tapping mechanic. The $HMSTR token, released on September 26, 2024, on The Open Network (TON), saw no presale but powers its 300 million-strong user base.",
    sector: "Play", 
    sectorUrl: "https://t.me/hamster_koMbat_bot/start?startapp=kentId1812207291",
    projectType: "Game Hub",
    buttons: [
      {
        label: "Open Website",
        url: "https://hamsterkombat.io/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/ton/pools/EQAlNk4VwBlVV-sQr0UYe5souU_xbTof54Fd9qewwN1N7pXL"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/hamster_kombat"
      },
      {
        label: "Follow X",
        url: "https://x.com/hamster_kombat"
      },
      {
        label: "Follow Youtube",
        url: "https://x.com/hamster_kombat"
      }
    ]
  }
},
{
  id: 3,
  projectName: "Catizen",
  content: "/assets/memes/game3.png",
  weight: 1,
  logo: "/assets/logos/logo_catizen.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true,
    network: "TON",
    price: "0.29",
    marketCap: "0.06B",
    priceChange24h: -1,
    contract: "EQD-cvR0Nz6XAyRBvbhz-abTrRC6sI5tvHvvpeQraV9UAAD7",
    buyLink: "https://www.binance.com/en/trade/CATI_USDT?ref=37754157&type=spot",
    description: "Catizen is a puzzle-based game where players raise and merge virtual cats, integrating GameFi and AI for a unique pet-owning experience. The $CATI token, released on September 20, 2024, on The Open Network (TON) without a presale, fuels its 34 million active users, with plans for further economic enhancements in 2025.",
    sector: "Play", 
    sectorUrl: "https://t.me/catizenbot/gameapp?startapp=rp_47060003",
    projectType: "Tapping Game",
    buttons: [
      {
        label: "Open Website",
        url: "https://catizen.ai/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/ton/pools/EQBJ_X3ysvgOGUo6XB3eUTCvagarGeA3X-QD3lxSqZzQbQ4w"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/CatizenAnn"
      },
      {
        label: "Follow X",
        url: "https://x.com/CatizenAI"
      }
    ]
  }
},
{
  id: 4,
  projectName: "Catizen",
  content: "/assets/memes/game4.png",
  weight: 1,
  logo: "/assets/logos/logo_catizen.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true,
    network: "TON",
    price: "0.29",
    marketCap: "0.06B",
    priceChange24h: -1,
    contract: "EQD-cvR0Nz6XAyRBvbhz-abTrRC6sI5tvHvvpeQraV9UAAD7",
    buyLink: "https://www.binance.com/en/trade/CATI_USDT?ref=37754157&type=spot",
    description: "Catizen is a puzzle-based game where players raise and merge virtual cats, integrating GameFi and AI for a unique pet-owning experience. The $CATI token, released on September 20, 2024, on The Open Network (TON) without a presale, fuels its 34 million active users, with plans for further economic enhancements in 2025.",
      sector: "Play", 
      sectorUrl: "https://t.me/catizenbot/gameapp?startapp=rp_47060003",
      projectType: "Tapping Game",
    buttons: [
      {
        label: "Open Website",
        url: "https://catizen.ai/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/ton/pools/EQBJ_X3ysvgOGUo6XB3eUTCvagarGeA3X-QD3lxSqZzQbQ4w"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/CatizenAnn"
      },
      {
        label: "Follow X",
        url: "https://x.com/CatizenAI"
      }
    ]
  }
},
{
  id: 5,
  projectName: "Play!",
  content: "/assets/memes/game5.png",
  weight: 1,
  logo: "/assets/logos/logo_play.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true,
    network: "Base",
    price: "1.38",
    marketCap: "2.3B",
    priceChange24h: -1,
    contract: "0x7404ac09adf614603d9c16a7ce85a1101f3514ba",
    buyLink: "https://app.uniswap.org/explore/tokens/base/0x7404ac09adf614603d9c16a7ce85a1101f3514ba",
    description: "Play is a Telegram mini-app offering a variety of casual games where users can engage in fun activities to earn points. No token has been released, but there’s speculation about a potential airdrop in the future tied to its growing ecosystem.",
    sector: "Play", 
    sectorUrl: "https://t.me/play_gamestore_bot/",
    projectType: "Game Hub",
    buttons: [
      {
        label: "Open Website",
        url: "https://theplay.network/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/base/pools/0x9d029df22ceefc6245d382a41bc232c8dc988bf9"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/PLAY_GameStore_Ann"
      },
      {
        label: "Follow X",
        url: "https://x.com/0xplay_network"
      },
      {
        label: "Join Discord",
        url: "https://x.com/0xplay_network"
      }
    ]
  }
},
{
  id: 6,
  projectName: "Play!",
  content: "/assets/memes/game6.png",
  weight: 1,
  logo: "/assets/logos/logo_play.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true,
    network: "Base",
    price: "1.38",
    marketCap: "2.3B",
    priceChange24h: -1,
    contract: "0x7404ac09adf614603d9c16a7ce85a1101f3514ba",
    buyLink: "https://app.uniswap.org/explore/tokens/base/0x7404ac09adf614603d9c16a7ce85a1101f3514ba",
    description: "Play is a Telegram mini-app offering a variety of casual games where users can engage in fun activities to earn points. No token has been released, but there’s speculation about a potential airdrop in the future tied to its growing ecosystem.",
    sector: "Play", 
    sectorUrl: "https://t.me/play_gamestore_bot/",
    projectType: "Game Hub",
    buttons: [
      {
        label: "Open Website",
        url: "https://theplay.network/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/base/pools/0x9d029df22ceefc6245d382a41bc232c8dc988bf9"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/PLAY_GameStore_Ann"
      },
      {
        label: "Follow X",
        url: "https://x.com/0xplay_network"
      },
      {
        label: "Join Discord",
        url: "https://x.com/0xplay_network"
      }
    ]
  }
},
{
  id: 7,
  projectName: "TONs of Dungeons",
  content: "/assets/memes/game7.png",
  weight: 1,
  logo: "/assets/logos/logo_dungeons.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, // Indicate this game has no token
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "TONs of Dungeons is an adventure game where players explore dungeons, collect treasures, and avoid traps to earn rewards. No token has been released yet, but a major airdrop is planned to incentivize player engagement.",
    sector: "Play", 
    sectorUrl: "https://t.me/tonsofdungeons_bot/TOD?startapp=cXd5q9uDl0-wSmOjSC-ipA",
    projectType: "Tapping Game",
    buttons: [
      {
        label: "Website",
        url: "https://tonsofdungeons.com/"
      },
      {
        label: "Price Chart",
        url: "N/A"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/tonsofdungeons_bot/"
      },
      {
        label: "Follow X",
        url: "https://x.com/tonsofdungeons"
      }
    ]
  }
},
{
  id: 8,
  projectName: "TONs of Dungeons",
  content: "/assets/memes/game8.png",
  weight: 1,
  logo: "/assets/logos/logo_dungeons.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "TONs of Dungeons is an adventure game where players explore dungeons, collect treasures, and avoid traps to earn rewards. No token has been released yet, but a major airdrop is planned to incentivize player engagement.",
    sector: "Play", 
    sectorUrl: "https://t.me/tonsofdungeons_bot/TOD?startapp=cXd5q9uDl0-wSmOjSC-ipA",
    projectType: "Tapping Game",
    buttons: [
      {
        label: "Website",
        url: "https://tonsofdungeons.com/"
      },
      {
        label: "Price Chart",
        url: "N/A"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/tonsofdungeons_bot/"
      },
      {
        label: "Follow X",
        url: "https://x.com/tonsofdungeons"
      }
    ]
  }
},
{
  id: 9,
  projectName: "Dogiators",
  content: "/assets/memes/game9.png",
  weight: 1,
  logo: "/assets/logos/logo_dogiators.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Dogiators is a 3D tap-to-earn game where players level up virtual dogs through battles and tasks to earn rewards. No token has been released, but an upcoming airdrop is anticipated to reward active players.",
    sector: "Play", 
    sectorUrl: "https://t.me/Dogiators_bot/game?startapp=htiHhZ7ACF2YDNaw",
    projectType: "PvP Game",
    buttons: [
      {
        label: "Join Telegram",
        url: "https://t.me/dogiators"
      }
    ]
  }
},
{
  id: 10,
  projectName: "Dogiators",
  content: "/assets/memes/game10.png",
  weight: 1,
  logo: "/assets/logos/logo_dogiators.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Dogiators is a 3D tap-to-earn game where players level up virtual dogs through battles and tasks to earn rewards. No token has been released, but an upcoming airdrop is anticipated to reward active players.",
    sector: "Play", 
    sectorUrl: "https://t.me/Dogiators_bot/game?startapp=htiHhZ7ACF2YDNaw",
    projectType: "PvP Game",
    buttons: [
      {
        label: "Join Telegram",
        url: "https://t.me/dogiators"
      }
    ]
  }
},
{
  id: 11,
  projectName: "Dragon Slither",
  content: "/assets/memes/game11.png",
  weight: 1,
  logo: "/assets/logos/logo_dragon.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Dragon Slither is a snake-type game on Telegram where players guide a 2D dragon to collect items and grow longer, earning points in a blockchain-powered arena. The $DRAGON token was released in 2024 on the Sei Network, with plans for the upcoming $DGN token in 2025.  ",
    sector: "Play", 
    sectorUrl: "https://t.me/DragonSlither_bot/Dragon?startapp=460453938",
    projectType: "Snake Game",
    buttons: [
      {
        label: "Website",
        url: "https://dragonslither.com/"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/DragonSlither"
      },
      {
        label: "Follow X",
        url: "https://x.com/Dragon_Slither"
      }
    ]
  }
},
{
  id: 12,
  projectName: "Dragon Slither",
  content: "/assets/memes/game12.png",
  weight: 1,
  logo: "/assets/logos/logo_dragon.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Dragon Slither is a snake-type game on Telegram where players guide a 2D dragon to collect items and grow longer, earning points in a blockchain-powered arena. The $DRAGON token was released in 2024 on the Sei Network, with plans for the upcoming $DGN token in 2025.  ",
    sector: "Play", 
    sectorUrl: "https://t.me/DragonSlither_bot/Dragon?startapp=460453938",
    projectType: "Snake Game",
    buttons: [
      {
        label: "Website",
        url: "https://dragonslither.com/"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/DragonSlither"
      },
      {
        label: "Follow X",
        url: "https://x.com/Dragon_Slither"
      }
    ]
  }
},
{
  id: 13,
  projectName: "Rocky Rabit",
  content: "/assets/memes/game13.png",
  weight: 1,
  logo: "/assets/logos/logo_rocky.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true,
    network: "TON",
    price: "0.003",
    marketCap: "0.24B",
    priceChange24h: -1,
    contract: "EQCD7lrrxpOcq5A5R6nTLeF1kuIbl1BKCe5OnanGe3cB4FVB",
    buyLink: "https://app.ston.fi/swap?ft=EQCD7lrrxpOcq5A5R6nTLeF1kuIbl1BKCe5OnanGe3cB4FVB&tt=EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c&chartVisible=false",
    description: "Rocky Rabbit is a tap-to-earn game where players train virtual rabbits for challenges, evolving into a broader play-to-earn platform. The $RBTC (RabBitcoin) token, released on September 23, 2024, on The Open Network (TON) without a presale, drives its 30 million active users toward new P2E features.",
    sector: "Play", 
    sectorUrl: "https://t.me/rocky_rabbit_bot/play?startapp=frId460453938",
    projectType: "Gamble",
    buttons: [
      {
        label: "Website",
        url: "https://rockyrabbit.io/"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/rockyrabbitio"
      },
      {
        label: "Follow X",
        url: "https://x.com/rockyrabbitio"
      },
      {
        label: "Youtube",
        url: "https://www.youtube.com/@rockyrabbitio"
      }
    ]
  }
},
{
  id: 14,
  projectName: "Rocky Rabit",
  content: "/assets/memes/game14.png",
  weight: 1,
  logo: "/assets/logos/logo_rocky.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true,
    network: "TON",
    price: "0.003",
    marketCap: "0.24B",
    priceChange24h: -1,
    contract: "EQCD7lrrxpOcq5A5R6nTLeF1kuIbl1BKCe5OnanGe3cB4FVB",
    buyLink: "https://app.ston.fi/swap?ft=EQCD7lrrxpOcq5A5R6nTLeF1kuIbl1BKCe5OnanGe3cB4FVB&tt=EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c&chartVisible=false",
    description: "Rocky Rabbit is a tap-to-earn game where players train virtual rabbits for challenges, evolving into a broader play-to-earn platform. The $RBTC (RabBitcoin) token, released on September 23, 2024, on The Open Network (TON) without a presale, drives its 30 million active users toward new P2E features.",
    sector: "Play", 
    sectorUrl: "https://t.me/rocky_rabbit_bot/play?startapp=frId460453938",
    projectType: "Gamble",
    buttons: [
      {
        label: "Website",
        url: "https://rockyrabbit.io/"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/rockyrabbitio"
      },
      {
        label: "Follow X",
        url: "https://x.com/rockyrabbitio"
      },
      {
        label: "Youtube",
        url: "https://www.youtube.com/@rockyrabbitio"
      }
    ]
  }
},
{
  id: 15,
  projectName: "WATcoin",
  content: "/assets/memes/game15.png",
  weight: 1,
  logo: "/assets/logos/logo_wat.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true, 
    network: "TON",
    price: "0.003",
    marketCap: "0.24B",
    priceChange24h: -1,
    contract: "EQCEqz2x3-Ub_EO4Y5798NNoqKw1tP_tJ6b9y-X0C4uvs8Zf",
    buyLink: "https://app.ston.fi/swap?ft=EQCqnhZndBGbwjPpV8K_8WOK58ZkQPXlS_bshau9DKWnAF-p&tt=EQCEqz2x3-Ub_EO4Y5798NNoqKw1tP_tJ6b9y-X0C4uvs8Zf&chartVisible=false",
    description: "WATCoin (WatBird) is a tap-to-earn game developed by Animoca Brands’ GAMEE, where players earn rewards through simple tasks and mini-games. The $WAT token was released on September 23, 2024, on The Open Network (TON). ",
    sector: "Play", 
    sectorUrl: "https://t.me/gamee/start?startapp=ref_460453938",
    projectType: "Game Hub",
    buttons: [
      {
        label: "Website",
        url: "https://points.gamee.com/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/ton/pools/EQA4c2edlFI4soyArI9Qa71dzt1a2zkO-a44u5RrQ7QG8rA9"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/watcoin"
      },
      {
        label: "Follow X",
        url: "https://x.com/WatBird"
      }
    ]
  }
},
{
  id: 16,
  projectName: "WATcoin",
  content: "/assets/memes/game16.png",
  weight: 1,
  logo: "/assets/logos/logo_wat.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: true, 
    network: "TON",
    price: "0.003",
    marketCap: "0.24B",
    priceChange24h: -1,
    contract: "EQCEqz2x3-Ub_EO4Y5798NNoqKw1tP_tJ6b9y-X0C4uvs8Zf",
    buyLink: "https://app.ston.fi/swap?ft=EQCqnhZndBGbwjPpV8K_8WOK58ZkQPXlS_bshau9DKWnAF-p&tt=EQCEqz2x3-Ub_EO4Y5798NNoqKw1tP_tJ6b9y-X0C4uvs8Zf&chartVisible=false",
    description: "WATCoin (WatBird) is a tap-to-earn game developed by Animoca Brands’ GAMEE, where players earn rewards through simple tasks and mini-games. The $WAT token was released on September 23, 2024, on The Open Network (TON). ",
    sector: "Play", 
    sectorUrl: "https://t.me/gamee/start?startapp=ref_460453938",
    projectType: "Game Hub",
    buttons: [
      {
        label: "Website",
        url: "https://points.gamee.com/"
      },
      {
        label: "Price Chart",
        url: "https://www.geckoterminal.com/ton/pools/EQA4c2edlFI4soyArI9Qa71dzt1a2zkO-a44u5RrQ7QG8rA9"
      },
      {
        label: "Join Telegram",
        url: "https://t.me/watcoin"
      },
      {
        label: "Follow X",
        url: "https://x.com/WatBird"
      }
    ]
  }
},
{
  id: 17,
  projectName: "HashCats",
  content: "/assets/memes/game17.png",
  weight: 1,
  logo: "/assets/logos/logo_hash.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Hashcats is a tap-to-earn game where players merge and upgrade virtual cats to boost their earnings in a crypto-themed setting. No token has been released yet, but an airdrop is speculated as part of its growing ecosystem. ",
    sector: "Play", 
    sectorUrl: "https://t.me/hash_cats_bot/app?startapp=fGoPIoI2Gb",
    projectType: "Tapping Game",
    buttons: [
      {
        label: "Join Telegram",
        url: "https://t.me/hash_cats"
      },
      {
        label: "Follow X",
        url: "https://x.com/HashCatsGame"
      },
      {
        label: "TGE Info",
        url: "https://x.com/HashCatsGame/status/1880599565436375486"
      }
    ]
  }
},
{
  id: 18,
  projectName: "HashCats",
  content: "/assets/memes/game18.png",
  weight: 1,
  logo: "/assets/logos/logo_hash.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Hashcats is a tap-to-earn game where players merge and upgrade virtual cats to boost their earnings in a crypto-themed setting. No token has been released yet, but an airdrop is speculated as part of its growing ecosystem. ",
    sector: "Play", 
    sectorUrl: "https://t.me/hash_cats_bot/app?startapp=fGoPIoI2Gb",
    projectType: "Tapping Game",
    buttons: [
      {
        label: "Join Telegram",
        url: "https://t.me/hash_cats"
      },
      {
        label: "Follow X",
        url: "https://x.com/HashCatsGame"
      },
      {
        label: "TGE Info",
        url: "https://x.com/HashCatsGame/status/1880599565436375486"
      }
    ]
  }
},
{
  id: 19,
  projectName: "Boinkers",
  content: "/assets/memes/game19.png",
  weight: 1,
  logo: "/assets/logos/logo_boinkers.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Boinkers is a casual tap-to-earn game where players accumulate points through simple, repetitive actions and upgrades. No token has been released, but an upcoming airdrop is hinted at to reward its active community.",
    sector: "Play", 
    sectorUrl: "https://t.me/boinker_bot/boinkapp?startapp=boink1812207291",
    projectType: "Tapping Game",
    buttons: [
      {
        label: "Join Telegram",
        url: "https://t.me/boinkersNews"
      },
      {
        label: "Follow X",
        url: "https://x.com/BoinkersIO"
      }
    ]
  }
},
{
  id: 20,
  projectName: "Boinkers",
  content: "/assets/memes/game20.png",
  weight: 1,
  logo: "/assets/logos/logo_boinkers.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Boinkers is a casual tap-to-earn game where players accumulate points through simple, repetitive actions and upgrades. No token has been released, but an upcoming airdrop is hinted at to reward its active community.",
    sector: "Play", 
    sectorUrl: "https://t.me/boinker_bot/boinkapp?startapp=boink1812207291",
    projectType: "Tapping Game",
    buttons: [
      {
        label: "Join Telegram",
        url: "https://t.me/boinkersNews"
      },
      {
        label: "Follow X",
        url: "https://x.com/BoinkersIO"
      }
    ]
  }
},
{
  id: 21,
  projectName: "Snake Lite",
  content: "/assets/memes/game21.png",
  weight: 1,
  logo: "/assets/logos/logo_snakelite.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Snake Lite is a Telegram mini-app game that modernizes the classic Snake gameplay, where players navigate a snake to collect items and earn points, integrating tap-to-earn mechanics with Web3 features. There’s no confirmed token presale or airdrop as of February 2025; however, its TGE is tentatively scheduled for Q1 2025 on The Open Network (TON), with community speculation on X suggesting a potential airdrop to reward early players around that time.",
    sector: "Play", 
    sectorUrl: "https://t.me/Snakelite_official_bot/Snakelite?startapp=L9TklWjj",
    projectType: "Snake Game",
    buttons: [
      {
        label: "Open Website",
        url: "https://snakelite.io/"
      },
      {
        label: "Telegram News",
        url: "https://t.me/SnakeLiteAnnouncement"
      },
      {
        label: "Follow X",
        url: "https://x.com/snakeliteio"
      },
      {
        label: "Telegram Chat",
        url: "https://t.me/SnakeLiteio"
      }
    ]
  }
},
{
  id: 22,
  projectName: "Snake Lite",
  content: "/assets/memes/game22.png",
  weight: 1,
  logo: "/assets/logos/logo_snakelite.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Snake Lite is a Telegram mini-app game that modernizes the classic Snake gameplay, where players navigate a snake to collect items and earn points, integrating tap-to-earn mechanics with Web3 features. There’s no confirmed token presale or airdrop as of February 2025; however, its TGE is tentatively scheduled for Q1 2025 on The Open Network (TON), with community speculation on X suggesting a potential airdrop to reward early players around that time.",
    sector: "Play", 
    sectorUrl: "https://t.me/Snakelite_official_bot/Snakelite?startapp=L9TklWjj",
    projectType: "Snake Game",
    buttons: [
      {
        label: "Open Website",
        url: "https://snakelite.io/"
      },
      {
        label: "Telegram News",
        url: "https://t.me/SnakeLiteAnnouncement"
      },
      {
        label: "Follow X",
        url: "https://x.com/snakeliteio"
      },
      {
        label: "Telegram Chat",
        url: "https://t.me/SnakeLiteio"
      }
    ]
  }
},
{
  id: 23,
  projectName: "Kitty Verse",
  content: "/assets/memes/game23.png",
  weight: 2,
  logo: "/assets/logos/logo_kitty.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Tap into Kittyverse, an innovative P2E game on Telegram! Earn $KITTY with fun kitty taps—airdrop coming soon. Presale live now—grab it cheap! Join 1.5M monthly players on TON’s purr-fect adventure!",
      sector: "Play", 
      sectorUrl: "https://t.me/kittyverse_ai_bot/play?startapp=u1812207291",
      projectType: "Snake Game",
      buttons: [
        {
          label: "Open Website",
          url: "https://kittyverse.ai/"
        },
        {
          label: "Telegram News",
          url: "https://t.me/kittyverse_ai"
        },
        {
          label: "Follow X",
          url: "https://x.com/kittyverse_ai"
        }
      ]
    }
  },
{
  id: 24,
    projectName: "Dragonz Land",
    content: "/assets/memes/game24.png",
    weight: 2,
    logo: "/assets/logos/logo_dragonz.png",
    engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Hatch & battle Dragonz in Dragonz Land, a P2E Telegram hit! Upgrade hives, fight for $DRAGON—over 50% of the token supply is used for airdrops. Mint NFTs and join 200K+ monthly players on TON’s epic adventure!",
      sector: "Play", 
      sectorUrl: "https://t.me/dragonz_land_bot/app?startapp=ref-67c49a3ccb30b54ee16c7fed",
      projectType: "Tapping Game",
      buttons: [
        {
          label: "Open Website",
          url: "https://www.dragonz.land/"
        },
        {
          label: "Telegram News",
          url: "https://t.me/dragonz_land_announcement"
        },
        {
          label: "Follow X",
          url: "https://x.com/dragonzlandx"
        }
      ]
    }
  },
{
  id: 25,
    projectName: "Rhinova",
    content: "/assets/memes/game25.png",
    weight: 1,
    logo: "/assets/logos/logo_rhinova.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Fight epic battles in Rhinova, a P2E Telegram game! Buy a $8 Luminary NFT, strategize, and earn up to $1,200 in events. Join 20K+ monthly players in this TON-powered adventure by GameOnCyborg & GotGame_DAO!",
      sector: "Play", 
      sectorUrl: "https://t.me/rhinova_bot/rhinovagame?startapp=27ESDnk6AjZ",
      projectType: "Tapping Game",
      buttons: [
        {
          label: "Follow X",
          url: "https://x.com/rhinova_game"
        },
        {
          label: "Telegram Chat",
          url: "https://t.me/rhinovachat"
        }
      ]
    }
  },
{
  id: 26,
    projectName: "Bombie",
    content: "/assets/memes/game26.png",
    weight: 2,
    logo: "/assets/logos/logo_bombie.png",
  engagement: {
    likes: 0,
    superLikes: 0,
    dislikes: 0
  },
  projectDetails: {
    hasToken: false, 
    network: null,
    price: null,
    marketCap: null,
    priceChange24h: null,
    contract: null,
    buyLink: null,
    description: "Blast zombies in Bombie, a thrilling P2E shooter! Upgrade skills, loot chests, and battle in arenas. Earn $Bombie tokens—70% of supply prepared for airdrops, no vesting. Join over 2M monthly players in this Web3 hit from Catizen!",
      sector: "Play", 
      sectorUrl: "https://t.me/Snakelite_official_bot/Snakelite?startapp=L9TklWjj",
      projectType: "Tapping Game",
      buttons: [
        {
          label: "Open Website",
          url: "https://bombie.xyz/"
        },
        {
          label: "Telegram News",
          url: "https://t.me/BombieNews"
        },
        {
          label: "Follow X",
          url: "https://x.com/Bombie_xyz"
        }
      ]
    }
  },

];

export default dummyMemes;